import { putSonarObjectStakeholdersBulk } from '@api';
import { refreshCurrentInitiativeSummarySaga } from '../../../initiatives/summary/get';
import { updateSonarObjectReferences } from '../../_idMap/actions';
import { createPutAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const putCoreSonarObjectsStakeholdersBulkSlice = createPutAsyncSlice({
	additionalReceiveSteps: [
		{
			actionHandler: refreshCurrentInitiativeSummarySaga,
			type: SagaYieldType.Latest
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences(
					request.sonarObjectIds.map((sonarObjectId) => ({
						sonarObjectId,
						stakeholders: request.stakeholderIds
					}))
				)
		]
	},
	name: 'CoreSonarObjectsStakeholdersBulk',
	receive: false,
	request: true,
	requestHandler: putSonarObjectStakeholdersBulk
});
